<template>
    <div id="thirdPartyDelivery">

        <Panel :title="$t('company.third_party_delivery.title')" collapsible>
            <div class="description">
                <span>{{$t('company.third_party_delivery.description')}}</span>
                <button class="btn btn-primary add" @click="addThirdPartyDeliveryPlatform">
                    <svgicon src="/icon/add.svg" height="15" width="15"></svgicon>
                </button>
            </div>
            <div class="platforms">
                <div class="platform" v-for="(platform, platformIndex) of thirdPartyDeliveryPlatforms">
                    <div class="title">
                        {{platform.name === 'other' ? platform.custom : platform.name }}
                        <div class="flex-grow"></div>
                        <button class="btn btn-primary remove" @click="removeThirdPartyDeliveryPlatform(platformIndex)">
                            <svgicon src="/icon/close.svg" height="15" width="15"></svgicon>
                        </button>
                    </div>
                    <div class="data">
                        <div class="group">
                            <label>{{$t('company.third_party_delivery.platform')}}</label>
                            <select v-model="platform.name">
                                <option value="">{{$t('company.third_party_delivery.choose')}}...</option>
                                <option :value="thirdPartyPlatform" v-for="thirdPartyPlatform of thirdPartyDeliveryPlatformsData">{{thirdPartyPlatform}}</option>
                                <option value="other">{{$t('branch.type.other')}}...</option>
                            </select>
                        </div>
                        <div class="group" v-if="platform.name === 'other'" >
                            <label>{{$t('company.third_party_delivery.name')}}</label>
                            <input type="text" v-model="platform.custom" :placeholder="$t('company.third_party_delivery.name')">
                        </div>
                        <div class="group">
                            <label>{{$t('company.third_party_delivery.link')}}</label>
                            <input type="text" v-model="platform.link" :placeholder="$t('company.third_party_delivery.link')">
                        </div>
                    </div>
                </div>
            </div>
        </Panel>

        <div class="footer-actions">
            <button class="btn btn-secondary" @click="back">{{$t("back")}}</button>
            <button class="btn btn-primary" @click="save">{{$t("save")}}</button>
        </div>

    </div>
</template>

<script>
  import Tooltip from "@/components/tools/Tooltip.vue";
  import {mapActions} from 'vuex';

  export default {
    name: "thirdPartyDelivery",

    components: { Tooltip },

    data() {
      return {
        id: null,
        thirdPartyDeliveryPlatformsData: [
          "DoorDash",
          "SkipTheDishes",
          "Uber Eats",
          "GrubHub",
          "Instacart",
          "goPuff",
          "Seamless",
        ],
        thirdPartyDeliveryPlatforms: [],
      }
    },

    async mounted() {
      this.$store.state.pageTitleTranslationKey = "company.third_party_delivery.title";
      this.$store.state.pageIcon = "/icon/branches.svg";
      if (this.$route.query.company) {
        this.id = this.$route.query.company;
        this.loadCompany();
      }
    },

    methods: {
      ...mapActions(["getCompany", "saveCompany"]),

      async loadCompany() {
        let response = await this.getCompany({
          branchId: this.$route.query.branch,
          companyId: this.id,
          fallback: true
        });
        if (response) {
          this.id = response.id;
          this.thirdPartyDeliveryPlatforms = response.thirdPartyDeliveryPlatforms || [];
        } else {
          toast(this.$t("error.no_server"), "error");
        }
      },

      async save() {
        this.$store.commit("showSpinner", true);
        await this.saveCompany({
          branchId: this.$route.query.branch,
          companyId: this.id,
          data: {
            thirdPartyDeliveryPlatforms: this.thirdPartyDeliveryPlatforms
          }
        });
        toast(this.$t("company.success"), "success");
        this.$store.commit("showSpinner", false);
      },

      addThirdPartyDeliveryPlatform() {
        this.thirdPartyDeliveryPlatforms.push({
          name: "",
          custom: "",
          link: ""
        });
      },

      removeThirdPartyDeliveryPlatform(index) {
        this.thirdPartyDeliveryPlatforms.splice(index, 1);
      },

      back() {
        this.$router.push(this.$router.buildContext("/settings/services/online-ordering"));
      }
    }
  }
</script>

<style lang="scss" scoped>
    .platform {
        fill: white;
        border-top: 1px dashed #ccc;
        padding-top: 20px;
        padding-bottom: 10px;

        .title {
            display: flex;
            justify-content: space-between;
            font-weight: bold;
            font-size: 18px;
        }

        .data {
            display: flex;

            .group {
                flex-grow: 1;
            }

            .group:first-child {
                max-width: 200px;
            }

            .group:not(:last-child) {
                margin-right: 10px;
            }
        }
    }

    .description {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        color: #888;

        .add {
            fill: white;
            margin-left: 20px;
        }
    }
</style>